import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';
import {
  initializeTierTags,
  presetsInitFetch,
  presetsSetActive,
} from '../../redux/actions';
import { getPresetsStatus, getPresetsInitResponse } from '../../redux/selectors';
import { Props } from './DeviationPopupDropZone';

export type StateProps = Pick<Props,
  | 'referer'
  | 'presetsInit'
  | 'presetsStatus'
>;
export type DispatchProps = Pick<Props,
  | 'initializeTierTags'
  | 'presetsInitFetch'
  | 'presetsSetActive'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
  referer: getEnv(state).originalReferrer,
  presetsInit: getPresetsInitResponse(state),
  presetsStatus: getPresetsStatus(state) || 'uninitialized',
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  initializeTierTags: (tierId: number, onError: () => void) =>
    dispatch(initializeTierTags({ tierId, onError })),
  presetsInitFetch: () => dispatch(presetsInitFetch(null)),
  presetsSetActive: presetId => dispatch(presetsSetActive(presetId)),
});

export default connect(mapStateToProps, mapDispatchToProps);
